// import { format } from "date-fns";
import { HasSentStatus } from "types/transportDocument.type";
import { UppdragScheduleDateType, UppdragStatus } from "types/uppdrag.type";
import { z } from "zod";

export const uppdragSchema = z.object({
  assignedToUserUuid: z
    .string({ message: "Obligatoriskt fält" })
    .uuid("Obligatoriskt fält"),
  // .nullable()
  // .optional(),
  scheduleDate: z.date({ message: "Obligatoriskt fält" }),
  scheduleDateType: z
    .enum(Object.values(UppdragScheduleDateType) as [string, ...string[]], {
      errorMap: () => ({
        message:
          "Välj en av: " + Object.values(UppdragScheduleDateType).join(", "),
      }),
    })
    .optional(),
  description: z.string().nullable().optional(),
  referenceNumber: z.string().nullable().optional(),
  isPrioritized: z.boolean().optional(),
  emailToCustomerStatus: z
    .enum(Object.values(HasSentStatus) as [string, ...string[]])
    .optional(),
  emailToWasteStationStatus: z
    .enum(Object.values(HasSentStatus) as [string, ...string[]])
    .optional(),
  emailToParentCustomerStatus: z
    .enum(Object.values(HasSentStatus) as [string, ...string[]])
    .optional(),
  status: z
    .enum(Object.values(UppdragStatus) as [string, ...string[]], {
      errorMap: () => ({
        message:
          "Välj en av: " + Object.values(UppdragScheduleDateType).join(", "),
      }),
    })
    .optional(),
  reportedWorkingHours: z.string().nullable().optional(),
  reportedDrivingHours: z.string().nullable().optional(),
  isTimeReportConfirmed: z.boolean().optional(),
});

export type TUppdragSchema = z.infer<typeof uppdragSchema>;
